import { Injectable } from '@angular/core';

import { SchedulerService } from '../../shared/services/scheduler.service';
import { ClientStartupConfigService } from '../../shared/shared-context/client-startup-config.service';
import { LazyLoadableModuleId } from '../lazy-loadable-module-id.enum';
import { ModulePriorityService } from '../module-priority.service';
import { NoopDownloadStrategyService } from './noop-download-strategy.service';
import { SchedulerDownloadStrategy } from './scheduler-download-strategy.service';

@Injectable({
    providedIn: 'root',
    useFactory: (
        clientStartupConfigService: ClientStartupConfigService,
        scheduler: SchedulerService,
        modulePriorityService: ModulePriorityService
    ) => {
        try {
            switch (clientStartupConfigService.config.chunkLoadStrategy) {
                case 'idle-callback':
                    return new SchedulerDownloadStrategy(scheduler, modulePriorityService);
                case 'noop':
                default:
                    return new NoopDownloadStrategyService();
            }
        } catch {
            return new NoopDownloadStrategyService();
        }
    },
    deps: [
        ClientStartupConfigService,
        SchedulerService,
        ModulePriorityService
    ]
})
export abstract class LazyViewDownloadStrategy {
    public abstract async shouldLoad(moduleId: LazyLoadableModuleId): Promise<void>;
}
